export enum CssVariables {
  COVER_HEIGHT = '--coverHeight',
}
